import React, { Component } from 'react'
import injectsheet from 'react-jss'
import {
    Row,
    Col,
} from 'reactstrap';

const styles={
    study:{
        textAlign: 'left',
        marginBottom: '3%',
        width: '90%',
        marginLeft:'5%',
        '& .title':{
            width: '100%',
            '@media screen and (max-width: 767px)':{
                marginTop: '3%',
                marginBottom: '3%',
            },
            '& h2':{
                textAlign: 'left',
                marginBottom: '3%',
                color: '#ea9044',
                position: 'relative',
                display: 'inline-block',
                borderBottom: '2px solid #91230c',
                '@media screen and (max-width: 767px)':{
                    fontSize: '1.6rem',
                    marginTop: '3%',
                    marginBottom: '3%',
                },
            },
        },
        '& h1':{
            color: '#91230c',
            '@media screen and (max-width: 767px)':{
                fontSize: '1.9rem',
            },
        },
        '& h6':{
            color: '#91230c',
            fontWeight: 'normal',
        },
        '& .fontwrapper':{
            fontWeight: 'bold',
        },
        '& p':{
            textAlign: 'justify',
            fontFamily: '"Open Sans", "Helvetica", Arial, sans-serif',
        },
        '& .col-md-4':{
            border: '1px solid #d0c8c8'
        }
    }
}

class Study extends Component {
    
    render(){
        const {classes} = this.props;
        return(
            <div className={classes.study}>
            <div className="title">
                <h2>Our Publications</h2>
            </div>
            <Row>
                <Col md="3"></Col>
                <Col md="4">
                    <h1>Abstract</h1>
                    <p>A Practice Book of Cell Biology</p>  

                    <h6><span className="fontwrapper">Publication:</span> Prithavi Publication, New Delhi.<br/>
                    <span className="fontwrapper">1st Edition:</span> 2012.<br/>
                    <span className="fontwrapper">2nd Edition:</span> 2015.<br/>
                    <span className="fontwrapper">ISBN:</span> 978-81-868-4520-8</h6>

                    <p>This practice book is prepared for the NET-JRF/ GATE/ SLATE aspirants. It contains about 1250 problems in MCQ format. These questions are prepared according to the NET exams pattern and divided in two parts –B & C. Total 27 chapters are prepared which includes sub-chapters too. Big chapters are divided into smaller sub-chapters like Cell Membrane, Endoplasmic Reticulum, Cell Signaling and Cell Cycle..</p>
                </Col>
                <Col md="1"></Col>
                <Col md="4">
                    <h1>Abstract</h1>
                    <p>A Practice Book of Biochemistry</p> 

                    <h6><span className="fontwrapper">Publication:</span> Prithavi Publication, New Delhi.<br/>
                    <span className="fontwrapper">1st Edition:</span> 2015.<br/>
                    <span className="fontwrapper">ISBN:</span> 97-81-86845-9804</h6>

                    <p>This practice book is prepared for the NET-JRF/ GATE/ SLATE aspirants. It contains about 1600 problems in MCQ format. These questions are prepared according to the NET exams pattern and divided in two parts –B & C. Total 31 chapters are prepared which includes sub-chapters too. The syllabus is divided into small chapters based on knowledge, understanding, skill and application of topics of the syllabus of NET exam.</p>
                </Col>
            </Row>
            </div>
        );
    }
}

export default injectsheet(styles)(Study);